import { Module } from "vuex";
import { RootState } from "@/store/types";
import { pushStatistic } from "./statistic";
import { applicationAttribute } from "./attributes";
import { pushApplication } from "./application";
import { pushTemplate } from "./templates";

export const pushModule: Module<{modules: any}, RootState> = {
  modules: {
    pushStatistic,
    pushApplication,
    applicationAttribute,
    pushTemplate,
  },
};
